import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Loader.module.css';

const Loader = (props) => {
    return (
        <div className={cn(styles.loader, props.className)}>
            <Spinner animation="border" {...props} />
        </div>
    );
};

Loader.propTypes = {
    className: PropTypes.string,
};

export default Loader;
